'use strict';

module.exports = (app) => app.controller('feParkedInvoiceCtrl', /* @ngInject */ function ($scope, $attrs, $http, feParkedInvoiceService) {
	// Attribute variables
	$scope.orderId = '';
	$scope.customer_id = '';
	$scope.url = '';
	// Variables from init
	$scope.customer_company_id = $attrs.customer_company_id;
	$scope.supplier_company_id = $attrs.supplier_company_id;
	$scope.invoice = {};

	$scope.loading = true;
	$scope.hasParkedInvoice = false;
	$scope.fail = false;
	$scope.done = false;
	$scope.errorMessage = "ERROR";

	const LIST_PARKED_INVOICES_ROUTE = 'client/my-admin/parked-invoices';

	var errorMessagesList = [
		{key: 400, val: 'Ungültige Eingabe'},
		{key: 404, val: 'Diese Rechnungsnummer ist bereits in der Datenbank vorhanden'},
		{key: 500, val: 'Serverfehler'}
	];

	/**
	 * Translate the code of error to message in German
	 * @param errCode
	 * @returns {string}
	 */
	function getMSG(errCode) {
		var msgText = "Undefinierter Fehler";
		errorMessagesList.forEach(function (item) {
			if (item.key === errCode) {
				msgText = item.val;
			}
		});
		return msgText;
	}

	/**
	 * Initialise variable after save page loaded
	 * @param customerId
	 * @param orderId
	 * @param customerGrId
	 * @param supplierGrId
	 */
	$scope.initSave = function (customerId, orderId, customerGrId, supplierGrId) {
		$scope.url = feParkedInvoiceService.url;
		// Invoice params
		$scope.orderId = orderId;
		$scope.customer_id = customerId;
		$scope.customer_company_id = customerGrId;
		$scope.supplier_company_id = supplierGrId;

		$scope.loading = true;
		$scope.hasParkedInvoice = false;

		$scope.loadParkedInvoicesIfExist();
	};

	/**
	 * Before setup a new ParkedInvoice, check if it is already exist.
	 * in case if it is exist. Setup a new one is not allowed
	 */
	$scope.loadParkedInvoicesIfExist = function () {
		feParkedInvoiceService.doesParkedInvoiceExists($scope.orderId).then((res) => {
			$scope.hasParkedInvoice = res.hasParkedInvoice;
		}).finally(() => {
			$scope.loading = false;
			$scope.$apply();
		});
	};

	/**
	 * Upload data into the Server
	 */
	$scope.uploadFile = function () {
		// Variable definition
		var uploadUrl = $scope.url + "/invoice/parked/";
		$scope.invoice.orderId = $scope.orderId;
		// ISO DateTime convert
		$scope.invoice.invoiceDate = isoDateTimeConverter($scope.invoice.invoiceDateLocale);

		feParkedInvoiceService.create($scope.invoice).then(() => {
			$scope.done = true;
		}, (error) => {
			console.error(error);
			var msg = getMSG(error.status);
			if (msg != null) {
				$scope.errorMessage = msg;
			}
			$scope.fail = true;
		})
	};

	/**
	 * function for converting
	 * @param dateTime
	 * @returns {string}
	 */
	var isoDateTimeConverter = function (dateTime) {
		return window.moment(dateTime)
            .startOf('day').format();
	};

	/**
	 * Redirect to order page
	 * @param orderId
	 */
	$scope.redirectToOrder = function (orderId) {
		var redirectUrl = 'my_adm/order/my_adm_order_show.htm&VS_ORDER_ID=' + orderId;
		window.openContent(redirectUrl, '');
	};

	/**
	 * Redirect to list of parked invoice
	 * @param orderId
	 */
	$scope.redirectToParkedInvoiceList = function () {
		window.setIFrameRoute(LIST_PARKED_INVOICES_ROUTE);
		var redirectUrl = `container.htm&if=${LIST_PARKED_INVOICES_ROUTE}`;
		window.openContent(redirectUrl, '');
	};
});
